// Typed client for GET /api/v1/content and GET /api/v1/content/{id}/download (ROADMAP.md v0.6.4).
// Replaces pages/HomePage/contentFiles.ts's hardcoded mock — the Content page now lists real
// catalogue records (an R2 object, or a link into farmOS/ERPNext's own UI) and asks the API for a
// short-lived signed URL only when a caller actually opens or downloads one (ADR-0005). The API
// never streams file bytes itself.

import { apiFetch } from './platformApi';

export interface ContentItem {
  content_item_id: string;
  provider: string;
  title: string;
  folder: string | null;
  tags: string | null;
  content_type: string | null;
  abrar_id: string | null;
}

export interface ContentDownloadUrl {
  url: string;
  expires_at: string | null;
}

export async function fetchContent(params?: { folder?: string; type?: string }): Promise<ContentItem[]> {
  const qs = new URLSearchParams();
  if (params?.folder) qs.set('folder', params.folder);
  if (params?.type) qs.set('type', params.type);
  const query = qs.toString();
  const res = await apiFetch(`/api/v1/content${query ? `?${query}` : ''}`);
  if (!res.ok) throw new Error(`GET /api/v1/content -> ${res.status}`);
  const body: unknown = await res.json();
  if (!Array.isArray(body)) throw new Error('GET /api/v1/content: expected a JSON array');
  return body as ContentItem[];
}

export async function fetchContentDownloadUrl(contentItemId: string): Promise<ContentDownloadUrl> {
  const res = await apiFetch(`/api/v1/content/${encodeURIComponent(contentItemId)}/download`);
  if (!res.ok) throw new Error(`GET /api/v1/content/${contentItemId}/download -> ${res.status}`);
  return (await res.json()) as ContentDownloadUrl;
}
